import { takeEvery, call, put, select, delay } from "redux-saga/effects";
import { buildGETUrl } from "../../../utilities/buildGETUrl";
import {
  DELETE_CLIPS,
  loadClips,
} from "../../../store/Settings/actions/components/Clips";
import { loadTracks, updateTracks } from "../../../store/Tracks/actions";
import { loadIndentObjects } from "../../../store/Objects/actions";
import { deleteMark } from "../../../store/Marks/actions";
import { showAlertSuccess, showAlertError } from "../../../store/Alert/actions";
import axios from "axios";
import reload from "../../Search/reload";
import { reloadValue } from "../../../store/Search/actions";
import { loading } from "../../../store/App/actions";

const DeLAY_TIME = 300;
const BATCH_SIZE = 100;

export default function* () {
  yield takeEvery(DELETE_CLIPS, worker);
}

function* worker({ payload }) {
  yield put(loading(true))
  const selectedTracks = yield select((state) => state.tracks.selected);
  const selectedObjects = yield select((state) => state.objects.selected);

  let indent_ids = payload.clipsDatas
    .map((el) => el.indent_ids)
    .reduce((unique, current) => {
      return [...new Set([...unique, ...current])];
    }, []);

  try {
    let clipsDatas = payload.clipsDatas.map((clipData) =>
      validateClipData(clipData)
    );

    // Последовательная отправка с delay каждые 3 запроса
    let clipsDeleted = [];

    for (let i = 0; i < clipsDatas.length; i++) {
      const clipData = clipsDatas[i];
      const result = yield call(fetchDelete, clipData);
      clipsDeleted.push(result);

      // Каждые 3 запроса делаем паузу DeLAY_TIME мс, кроме последнего
      if ((i + 1) % BATCH_SIZE === 0 && i + 1 < clipsDatas.length) {
        yield delay(DeLAY_TIME);
      }
    }

    // Проверка на ошибки
    let isError = false;
    let errorMessage = "";
    clipsDeleted.forEach((clip) => {
      if (clip.error) {
        isError = true;
        errorMessage = clip.error;
      }
    });

    if (isError) {
      yield put(
        showAlertError({
          errors: [`Ошибка сервера при ${DELETE_CLIPS}.`, clipsDeleted],
          text:
            "Не все расписания были удалены. Попробуйте повторить. " +
            errorMessage,
        })
      );
    } else {
      yield put(
        showAlertSuccess({
          responses: [`Успешное выполнение ${DELETE_CLIPS}.`, clipsDeleted],
          text: "Все расписания были удалены.",
        })
      );

      yield put(loadTracks({ callback: reloadValue }));
      yield put(loadTracks({ theme: true }));
      yield put(loadIndentObjects());


      yield put(
        loadClips({
          indentIds: selectedTracks,
          objectIds: selectedObjects,
          required: true,
        })
      );


      for (const clipData of clipsDatas) {
        if (clipData.mark) {
          yield put(deleteMark(clipData.mark));
        }
      }
    }

    const updated_clips = yield call(loadClipSelect, indent_ids);

    yield put(
      updateTracks(
        updated_clips.success.reduce((acc, el) => {
          acc[el.id] = el;
          return acc;
        }, {})
      )
    );
  } catch (e) {
    yield put(
      showAlertError({
        errors: [`Ошибка сети при ${DELETE_CLIPS}.`, e],
        text: "Не все расписания были удалены. Попробуйте повторить.",
      })
    );
  }
  finally {
    yield put(loading(false))
  }
}

function loadClipSelect(indent_ids) {
  const params = new URLSearchParams();
  indent_ids.forEach((id) => {
    params.append("id[]", id);
  });

  return axios
    .get("/clip/select", {
      params: params,
    })
    .then((response) => response.data);
}

function fetchDelete(clipData) {
  let params = {
    fromdate: clipData.fromdate,
    todate: clipData.todate,
    channel: clipData.channel,
    indent_id: clipData.indent_ids,
    ms_id: clipData.ms_id,
  };

  if (clipData.mark) {
    params = {
      mark: clipData.mark,
      channel: clipData.channel,
      indent_id: clipData.indent_ids,
      ms_id: clipData.ms_id,
    };
  }

  return axios
    .get("/timeline/clip/delete", {
      params: params,
    })
    .then((response) => response.data);
}

function validateClipData(clipData) {
  if (Array.isArray(clipData.indentIds))
    clipData.indentId = clipData.indentIds.join(",");
  if (Array.isArray(clipData.indentId))
    clipData.indentId = clipData.indentId.join(",");
  if (Array.isArray(clipData.objectIds))
    clipData.objectId = clipData.objectIds.join(",");
  if (Array.isArray(clipData.objectId))
    clipData.objectId = clipData.objectId.join(",");

  if (clipData.indentId) clipData.indent_id = clipData.indentId;
  if (clipData.objectId) clipData.ms_id = clipData.objectId;

  delete clipData.indentIds;
  delete clipData.indentId;
  delete clipData.objectIds;
  delete clipData.objectId;
  delete clipData.__inday;

  return clipData;
}